import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_EAM_Seo() {
  return (
    <Helmet>
      <title>
        Infor EPM Indonesia | Enterprise Performance Management by PT Supersoft
        Sistemindo
      </title>
      <meta
        name="description"
        content="Infor EPM membantu perusahaan merencanakan, memantau, dan menganalisis performa bisnis secara real-time. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia."
      />
      <meta
        name="keywords"
        content="Infor EPM Indonesia, Enterprise Performance Management, Infor Partner Indonesia, PT Supersoft Sistemindo, software perencanaan bisnis, performance analytics"
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/enterprise-performance-management"
      />

      {/* ==== Open Graph ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/enterprise-performance-management"
      />
      <meta
        property="og:title"
        content="Infor EPM Indonesia | Enterprise Performance Management Solution"
      />
      <meta
        property="og:description"
        content="Optimalkan kinerja organisasi dengan Infor EPM — solusi perencanaan dan analisis performa bisnis. Partner resmi: PT Supersoft Sistemindo."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets/epm_banner.png"
      />

      {/* ==== AI Search Optimization ==== */}
      <meta
        name="ai-keywords"
        content="Infor EPM Indonesia, enterprise performance management, business analytics Indonesia, corporate planning software, PT Supersoft Sistemindo"
      />
      <meta
        name="ai-summary"
        content="Infor EPM menyediakan integrasi perencanaan, budgeting, forecasting, dan analitik untuk membantu pengambilan keputusan berbasis data di Indonesia."
      />

      {/* ==== FAQ Schema ==== */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Apa itu Infor EPM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor Enterprise Performance Management (EPM) adalah solusi untuk perencanaan, penganggaran, dan analisis performa bisnis. Supersoft menyediakan lisensi dan implementasi di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What is Infor EPM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Infor EPM integrates planning, budgeting, forecasting, and analytics in one platform. PT Supersoft Sistemindo provides full implementation and support in Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "Apa manfaat utama Infor EPM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Meningkatkan akurasi perencanaan dan mempercepat proses pelaporan melalui visualisasi data yang real-time."
            }
          }
        ]
      }
      `}</script>
    </Helmet>
  );
}

export default SSoft_Solution_EAM_Seo;
